import { logger } from './logger';
import { LogCategory } from "@/logging/types";
import { telemetrySync } from './telemetrySync';

let isRegistered = false

function buildContext(extra = {}) {
    return {
        visibilityState: document.visibilityState,
        referrer: document.referrer || null,
        ...extra,
    }
}

// route is unset until the first navigation; query stripped because auth.js forwards it.
function bootPath() {
    return globalThis.location.hash.replace(/^#/, '').split('?')[0] || '/'
}

export function initLifecycleLogging() {
    if (isRegistered) return
    isRegistered = true

    logger.info(
        LogCategory.APP_LIFECYCLE,
        'app.startup',
        buildContext({ bootPath: bootPath() }),
        'App startup detected',
    ).then()

    const onOnline = () => {
        logger.info(
            LogCategory.APP_LIFECYCLE,
            'connectivity.changed',
            buildContext({ status: 'online' }),
            'Connectivity changed',
        ).then()
        telemetrySync.requestDrain('online').then()
    }

    const onOffline = () => {
        logger.warn(
            LogCategory.APP_LIFECYCLE,
            'connectivity.changed',
            buildContext({ status: 'offline' }),
            'Connectivity changed',
        ).then()
    }

    const onVisibilityChange = () => {
        if (document.visibilityState === 'visible') {
            logger.info(
                LogCategory.APP_LIFECYCLE,
                'app.resume',
                buildContext({ trigger: 'visibilitychange' }),
                'App resumed',
            ).then()
            telemetrySync.requestDrain('resume').then()
        }
    }

    const onPageShow = (event) => {
        if (event.persisted) {
            logger.info(
                LogCategory.APP_LIFECYCLE,
                'app.resume',
                buildContext({ trigger: 'pageshow', persisted: true }),
                'App restored from page cache',
            ).then()
            telemetrySync.requestDrain('resume').then()
        }
    }

    const onPageHide = () => {
        telemetrySync.beacon()
    }

    globalThis.addEventListener('online', onOnline)
    globalThis.addEventListener('offline', onOffline)
    document.addEventListener('visibilitychange', onVisibilityChange)
    globalThis.addEventListener('pageshow', onPageShow)
    globalThis.addEventListener('pagehide', onPageHide)

    globalThis.addEventListener('error', (event) => {
        logger.error(
            LogCategory.APP_LIFECYCLE,
            'error.unhandled',
            buildContext({
                message: event.message,
                filename: event.filename,
                line: event.lineno,
                column: event.colno,
            }),
            'Unhandled runtime error',
        ).then()
    })

    globalThis.addEventListener('unhandledrejection', (event) => {
        const reason = event.reason?.message ? event.reason.message : String(event.reason)
        logger.error(
            LogCategory.APP_LIFECYCLE,
            'error.unhandled.rejection',
            buildContext({ reason }),
            'Unhandled promise rejection',
        ).then()
    })

    telemetrySync.start()
}


